module.exports = __webpack_public_path__ + "img/reference24.89a043a6.jpg";